import './css/style.css';
import konfig from './konfig.js';
import main from './js/main.js';

main.createModule(document.getElementById("map"), konfig);

